<template>
  <div>
    <h3 class="page__title">流水变动日报</h3>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black">
        <div class="weui-cell__hd">
            <label class="weui-label">开始日期</label>
        </div>
        <div class="weui-cell__bd" @click="pickerDate" >
          <a style="align-text:left ;color: #238E23;">{{dateStr}}</a>
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black">
        <div class="weui-cell__hd">
            <label class="weui-label">截止日期</label>
        </div>
        <div class="weui-cell__bd" @click="pickerEndDate" >
          <a style="align-text:left ;color: #238E23;">{{dateEndStr}}</a>
        </div>
    </div>
    <div class="weui-navbar">
        <div class="weui-navbar__item weui-bar__item_on" id="nav_wx" >
            微信支付
        </div>
        <div class="weui-navbar__item" id="nav_balance" v-show="(partnerid == 'M2022060001')">
            储值卡
        </div>
        <div class="weui-navbar__item" id="nav_ld">
            链点
        </div>
    </div>
    <div class="weui-tab__panel" v-show="(resData != null)">

      <div class="table-responsive" v-if="reportData.length > 0">
        <table class="table table-striped " style="font-size: small;" >
          <thead>
            <tr>
              <th scope="col">日期范围</th>
              <th scope="col">流入</th>
              <th scope="col">流出</th>
              <th scope="col">净流入</th>

            </tr>
            <tr  style="background-color:bisque;">
              <td>汇总</td>
              <td>￥{{fenToCNY(this.totalReportData.inAmount)}}<br/>共{{this.totalReportData.inCount}}笔</td>
              <td>￥{{fenToCNY(this.totalReportData.outAmount)}}<br/>共{{this.totalReportData.outCount}}笔</td>
              <td>￥{{fenToCNY(this.totalReportData.realAmount)}}</td>
            </tr>
          </thead>
          <tbody v-if="reportData.length > 0">
             <tr v-for="itm in reportData" :key="itm.date">
              <th scope="row">{{itm.date}}</th>
              <td>￥{{fenToCNY(itm.inAmount)}}<br/>共{{itm.inCount}}笔</td>
              <td>￥{{fenToCNY(itm.outAmount)}}<br/>共<span @click="toDir(itm.date, 4)">{{itm.outCount}}</span>笔</td>
              <td>￥{{fenToCNY(itm.realAmount)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <boxGraph ref="chart_line_box" style="height:300px;width:100%;"  />
  </div>
</template>

<style>
.underline_span{
  font:bold;
  text-underline-offset: 1px;
}

</style>

<script>
import boxGraph from '../components/boxGraph.vue'

import 'bootstrap/dist/css/bootstrap.css'

import JQ from 'jquery'

import {getAllFlowDailyReport,findAllWeChatAccDailyStatement} from '../graphql/api'

function get2Str(str){
  return padding1(str,2);
}
function padding1(num, length) {
  for(var len = (num + "").length; len < length; len = num.length) {
   num = "0" + num;
  }
  return num;
 }


export default {


  data () {
    return {
      ing:true,
      openid:"",
      partnerid:"",
      date:this.$moment(new Date(),'YYYY-MM-01'),
      dateStr : this.$moment(new Date(),'YYYY-MM-01').format('YYYY-MM-01') ,
      dateEnd:new Date(),
      dateEndStr : new Date().Format("yyyy-MM-dd") ,
      reportData : [],
      totalReportData: {inAmount:0,inCount:0,outAmount:0,outCount:0,realAmount:0},
      mode : "nav_wx",
      resData: null

    }
  },
  watch :{
    ing(val,oval){
      console.log(val,oval);
    }
  },
  mounted() {
    this.openid = sessionStorage.getItem("openid")
    this.partnerid = sessionStorage.getItem("partnerid")

    let that = this;

    JQ('.weui-navbar__item').on('click', function () {
        JQ(this).addClass('weui-bar__item_on').siblings('.weui-bar__item_on').removeClass('weui-bar__item_on');
        console.log(JQ(this).attr("id"))
        that.mode = JQ(this).attr("id")
        console.log(that.mode)

        that.fillData();

    });


    this.getReport();

  },
    components: {
       boxGraph,
    },
  methods: {

  fenToCNY(fen){
    let prefix = "";
    let res= ""
    let intv = parseInt(fen)

    if(intv < 0) {
      intv = Math.abs(intv);
      prefix = "-";
    }

    if(intv <= 9){
      res = "0.0"+ ( intv).toString();
    }else if(intv <= 99){
      res =  "0."+ ( intv).toString();
    }else {
      res = intv.toString();

      res = res.substring(0,res.length-2) + "." + res.substring(res.length-2)
    }
    return prefix+res;

 },
    pickerDate() {
      let that = this;
      this.$weui.datePicker({
            start: 2022,
            end: new Date().getFullYear(),
            onChange: function (result) {
                console.log(result);
                console.log(result[0].value +"-"+ result[1].value +"-"+ result[2].value );
            },
            onConfirm: function (result) {
                console.log(result);
                that.dateStr = result[0].value +"-"+ get2Str(result[1].value) +"-"+ get2Str(result[2].value);
                that.date = new Date(result[0].value,result[1].value,result[2].value)
                that.getReport(that.dateStr);
            },
            title: '请选择开始日期'
        });
    },
    pickerEndDate() {
      let that = this;
      this.$weui.datePicker({
            start: 2022,
            end: new Date().getFullYear(),
            onChange: function (result) {
                console.log(result);
                console.log(result[0].value +"-"+ result[1].value +"-"+ result[2].value );
            },
            onConfirm: function (result) {
                console.log(result);
                that.dateEnd = new Date(result[0].value,result[1].value,result[2].value)
                that.dateEndStr = result[0].value +"-"+ get2Str(result[1].value) +"-"+ get2Str(result[2].value);
                that.getReport(that.dateStr);
            },
            title: '请选择结束日期'
        });
    },
    showError(){
      var $warnToast = JQ('#warnToast');
      $warnToast.fadeIn(100);
      setTimeout(function () {
          $warnToast.fadeOut(100);
      }, 2000);
    },
    fillData(){

      this.totalReportData = {inAmount:0,inCount:0,outAmount:0,outCount:0,realAmount:0};
      if((this.resData == null)) {
        this.getReport();return;
      }

      let res = this.resData.findAllWeChatAccDailyStatement

      if(this.mode == 'nav_wx'){
        res = this.resData.findAllWeChatAccDailyStatement
      }else if(this.mode == 'nav_balance'){
        res = this.resData.findAllYcbAccDailyStatement
      }else if(this.mode == 'nav_ld'){
        res = this.resData.findPointsDailyStatement // findAllPointsStatement
      }

        if(res.length ==0){
          // alert("选定的日期没有数据");
          that.reportData = [];
          that.$refs.chart_line_box.initChart([],[],[],[])
          return;
        }
      let that = this;


      let xDate =[];
      let yDataIn =[];
      let yDataOut =[];
      let yDataReal =[];

        res.forEach(item => {
          item.realAmount = item.inAmount - item.outAmount;

          that.totalReportData.inCount += item.inCount;
          that.totalReportData.inAmount += item.inAmount;
          that.totalReportData.outCount += item.outCount;
          that.totalReportData.outAmount += item.outAmount;
          that.totalReportData.realAmount += item.realAmount;


          xDate.push(item.date);
          yDataIn.push(that.fenToCNY(item.inAmount));
          yDataOut.push(that.fenToCNY(item.outAmount));
          yDataReal.push(that.fenToCNY(item.realAmount));
        })

        that.reportData = res
       that.ing=false;
       console.log( that.totalReportData)


        let arrSerial = ['流入', '流出', '净流入'];
        that.$refs.chart_line_box.initChart(xDate,yDataIn,yDataOut,yDataReal,arrSerial)


    },
    toDir(date, state) {
      this.$router.push({
        name: "orderlist", params: {
          dateStr: date,
          state: state,
          posid: 0
        }
      });
    },
    getReport(){


      console.log("getReport---------------------------------------------------------------------------------------")

      let that = this;
      this.ing=true;

      that.resData = null;

      let paras = {};

      paras.pid = this.partnerid;
      paras.bd = this.dateStr + " 00:00:00";
      paras.ed = this.dateEndStr + " 23:59:59";
      paras.ls = [1,2];
      paras.lt = null;//[1,2,3,4];
      paras.openid = that.openid;

      getAllFlowDailyReport(paras)
      // findAllWeChatAccDailyStatement(that.partnerid,{bd:"2022-12-01",ed:"2022-12-05 23:59:59",ls:[1,2],lt:[1,2,3,4]})
      .catch(err=>{
        console.log(err)
      })
      .then(res1=>{
        console.info('获取数据=》'+JSON.stringify(res1.data))

        that.resData = res1.data;

        that.fillData();

      })

    }
  }
}

</script>

<style>
.weui-navbar {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  position: relative;
  z-index: 500;
  background-color: #fff !important;
}

.weui-navbar__item:active {
  background-color: #ececec !important;
}

.weui-navbar__item.weui-bar__item_on {
  background-color: #ececec !important;
}



</style>



// WEBPACK FOOTER //
// src/views/report_flow_all.vue